const Home = () => {
  //console.log(userInfo);
  return (
    <div className="flex" style={{ margin: '50px', flexDirection: 'column' }}>
      <section className="flex" style={{ flexDirection: 'column' }}>
        {' '}
        <h4>Japanese vocabulary </h4> <h4>N2 </h4>
        <p> To start learning select 'Learn'.</p>
        <p> To test your knowledge select 'Test'.</p>
        <p>
          {' '}
          The course is divided into 35 units each containing 50 words. Should
          you chose 'All' option you will be work with the entire word dataset.
          If you want to save your progress till your next visit you have to
          register.{' '}
        </p>
        <p>
          After you reach a certain number of points, you will be prompted to
          pass to the next lesson. The number of points to gain within one
          lesson is increasing with each lesson. So, for example, for the first
          lesson you should earn 100 points, for the second 200 points.
        </p>
      </section>
    </div>
  );
};

export default Home;
